<template>
	<div class="header flex justify-between align-center">
		<div class="logo"></div>
		<div class="nav-bar text-white">
			<router-link to="/" class="item">视频教程</router-link>
			<router-link to="/" class="item">帮助文档</router-link>
			<router-link to="/" class="item">联系客服</router-link>
		</div>
	</div>
</template>

<script>
export default {
	props: {},
	data() {
		return {};
	},
	methods: {},
	onLoad() {}
};
</script>

<style lang="scss" scoped>
.header {
	width: 100%;
	height: 68px;
	background-color: $black;
	padding: 0 30px;
	padding-right: 45px;
	.logo {
		width: 44px;
		height: 44px;
		background: #1166a5;
		border-radius: 4px;
		overflow: hidden;
	}
	.nav-bar {
		font-size: 16px;
		.item {
			height: 68px;
			line-height: 68px;
			padding: 0 15px;
			display: inline-block;
		}
	}
}
</style>
